// extracted by mini-css-extract-plugin
export default {"simpleBuiPaginationContainer":"SimpleBuiPagination_simpleBuiPaginationContainer__jPgNg"};